import _ from 'lodash';
import Vue from 'vue';
import {
    getShopData, 
    getNoPageShopData,
    eidtShopData, 
    submitCategoryTask, 
    querySubmitCategoryResult,
    eidtWxsphShopData,
    operateCacheByShop
} from '@api/base/index.js';
import { PLATFORMS_ICONS, CHANNELS } from '@/dictionary/platforms.js'


/** 店铺管理 */
// 同步店铺类目
export const syncShopCategory = (data) => {
    return submitCategoryTask(data).then(res => {
        return res.result === 1
    })
}
// 解除店铺异常
export const secureAbnormalStates = (data) => {
    return operateCacheByShop(data).then(res => {
        return res.result === 1
    })
}
// 查看店铺类目同步进度
export const getSyncShopCategoryStatus = (data) => {
    return querySubmitCategoryResult(data).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
            return false
        }
    })
}

// 修改视频号信息
export const editWxsphShop = (data) => {
    return eidtWxsphShopData(data).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

// 获取店铺列表
export const getShopList = (params, opts = {}) => {
    return getShopData(params, opts).then(res => {
        const data = res.data;
        return {
            list: formatShopList(data.list || []),
            page: _.assign({total: data.total || 0}, data.page)
        }
    })
}
// 获取所有店铺列表
export const getAllShopList = (params, opts = {}) => {
    return getNoPageShopData(params, opts).then(res => {
        const data = res.data || {};
        return {
            list: formatShopList(data.list || []),
            page: _.assign({total: data.total || 0}, data.page)
        }
    })
}

// 修改店铺信息
export const editShop = (data) => {
    const params = {
        title: data.title,
        remark: data.remark,
        id: data.id,
        userId: data.userId,
        tradeSync: data.tradeSync,
        sendContactId: getSendContactId(data.sendAddressList),
        refundContactId: getRefundContactId(data.refundAddressList),
        taobaoId: data.taobaoId,
        sendAddressList: data.sendAddressList,
        refundAddressList: data.refundAddressList,
        source: data.source,
        subSource: data.subSource ? data.subSource : '',
        shortTitle: data.shortTitle,
        forceSendGoodsForDelay: data.forceSendGoodsForDelay,
        syncShipping: data.syncShipping,
        appKey: data?.appKey
    }
    return eidtShopData(params);
}

export const formatShopList = (list) => {
    return list.map((item) => {
        if (item.subSource === 'tjb') {
            item.icon = PLATFORMS_ICONS[item.subSource];
        } else {
            item.icon = PLATFORMS_ICONS[item.oldSource || item.source];
        }
        if(Vue.prototype.$fromGyl) {
            const channel = CHANNELS[item.channel] || {}
            item.channelIcon = channel.icon || ''
            item.channelName = channel.name || ''
        }
        return item;
    });
}

function getSendContactId(sendAddressList = []) {
    for (let item of sendAddressList) {
        if (item.getDef === 1) {
            return item.contactId;
        }
    }
    return '';
}
function getRefundContactId(refundAddressList = []) {
    for (let item of refundAddressList) {
        if (item.cancelDef === 1) {
            return item.contactId;
        }
    }
    return '';
}

